// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"AdminDashboard_dashboardContainer__P4c7U","topSalesAndPendingTickets":"AdminDashboard_topSalesAndPendingTickets__ZdZWU"};